export { RadioStatic } from './radio-static';
